<template>
  <div class="redirect-blank-modal">
    <p class="redirect-blank-modal__p--no-margin modal__text">
      {{ translate('checkout.dialog_text_bike') }}
    </p>
  </div>
</template>
<script setup lang="ts">
import { translate } from '@/i18n/i18n'
</script>
<style lang="scss"></style>
